module.exports = __webpack_public_path__ + "static/media/KN.64436eea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/KN.svg
// module id = 248
// module chunks = 0